import { isEmpty } from 'ramda';
import { noop } from 'ramda-adjunct';
import React, { FC, useCallback, useState } from 'react';
import { generateRandomGuid4 } from '../../../critical/utils';
import { useTrackSearchAndFiltersAnalytics } from '../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import { ClickOrigins } from '../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { WSRSearch } from '..';
import { IOuter } from './Search.types';

export const Search: FC<IOuter> = ({
  value: valueFromProps = '',
  dataHook = 'search-input',
  onEnterPressed = noop,
  onClearButtonClick = noop,
  biParams = {},
  className,
  placeholder,
  isExpandable,
}) => {
  const { trackSearchAndFiltersStarted } = useTrackSearchAndFiltersAnalytics();

  const [value, setValue] = useState(valueFromProps);
  const clearValue = useCallback(() => setValue(''), []);
  const handleChange = useCallback((event) => setValue(event.target.value), []);

  const handleEnterPressed = useCallback(() => {
    if (isEmpty(value)) {
      return;
    }

    trackSearchAndFiltersStarted({
      target: value,
      clickOrigin: ClickOrigins.Search,
      correlationId: generateRandomGuid4(),
      ...biParams,
    });

    onEnterPressed(value);
  }, [value, trackSearchAndFiltersStarted, onEnterPressed, biParams]);

  const handleButtonClearClick = useCallback(() => {
    clearValue();
    onClearButtonClick();
  }, [onClearButtonClick, clearValue]);

  const handleSearchBlur = useCallback(() => {
    if (isEmpty(value)) {
      clearValue();
      onClearButtonClick();
    }
  }, [value, clearValue, onClearButtonClick]);

  return (
    <WSRSearch
      value={value}
      onChange={handleChange}
      onBlur={handleSearchBlur}
      onEnterPressed={handleEnterPressed}
      onClear={handleButtonClearClick}
      placeholder={placeholder}
      expandWidth="100%"
      dataHook={dataHook}
      className={className}
      expandable={isExpandable}
    />
  );
};
